<template>
  <div class="ant-spin-nested-loading">
    <div class="loading" v-if="lodingShow">
      <div class="ant-spin ant-spin-spinning _2PSsJSST">
        <span class="ant-spin-dot ant-spin-dot-spin"><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i></span>
      </div>
    </div>
    <div :class="lodingShow ? 'ant-spin-container ant-spin-blur' : 'ant-spin-container'">
      <div class="_25BGlJ4o">
        <div class="_4ICMeQUV" style="border: none">
          <div class="T5pPAuRQ">会员互转<span>将中心钱包余额转给站内其他会员，转账成功后无法撤回</span></div>
        </div>
        <div class="_3AwqQ9Nt" style="margin-bottom: 20px">
          <div class="_3uhGlsJA">中心钱包</div>
          <div class="_222AIEz7">¥{{ $store.state.userInfo.balance }}元</div>
          <div class="wEDAX4ja" @click="refreshusermoney" style="cursor: pointer">刷新</div>
        </div>
        <form class="ant-form ant-form-horizontal _1JCYefEr">
          <div class="_3Pl0cJXW">
            <div class="_1pDMxc1H _32QwQ_nM">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label class="ant-form-item-required" title="对方会员号">对方会员号</label>
                </div>
                <div class="ant-col ant-form-item-control">
                  <div class="ant-form-item-control-input">
                    <div class="ant-form-item-control-input-content">
                      <span class="_3ON7kyGT ant-input-affix-wrapper">
                        <input autocomplete="off" class="ant-input" type="text" v-model="username" placeholder="请输入对方会员账号" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="_1pDMxc1H _32QwQ_nM">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label class="ant-form-item-required" title="转账金额">转账金额</label>
                </div>
                <div class="ant-col ant-form-item-control">
                  <div class="ant-form-item-control-input">
                    <div class="ant-form-item-control-input-content" style="display: flex; align-items: center">
                      <span class="_3ON7kyGT ant-input-affix-wrapper" style="flex: 1">
                        <input autocomplete="off" class="ant-input" type="number" v-model="amount" placeholder="请输入转账金额" />
                      </span>
                      <a href="javascript:;" style="margin-left: 12px; white-space: nowrap" @click="amount = $store.state.userInfo.balance">最大金额</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="_1pDMxc1H _32QwQ_nM">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label class="ant-form-item-required" title="支付密码">支付密码</label>
                </div>
                <div class="ant-col ant-form-item-control">
                  <div class="ant-form-item-control-input">
                    <div class="ant-form-item-control-input-content">
                      <span class="_3ON7kyGT ant-input-affix-wrapper">
                        <input autocomplete="new-password" class="ant-input" type="password" v-model="password" placeholder="请输入支付密码" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="_349CzCYy xJQe3jRu z0QZN3OV" :class="{ 'z0QZN3OV--disabled': submitting }" @click="doTransfer"><span>{{ submitting ? '转账中...' : '确认转账' }}</span></div>
            <div style="color: #999; margin-top: 12px; font-size: 13px">转账前请仔细核对对方会员号，转账成功后无法撤回</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'memberTransfer',
  data() {
    return {
      username: null,
      amount: null,
      password: null,
      lodingShow: false,
      submitting: false,
    };
  },
  methods: {
    doTransfer() {
      let that = this;
      if (that.submitting) {
        return;
      }
      let username = that.username ? String(that.username).trim() : '';
      let amount = that.amount;
      let password = that.password;
      if (!username) {
        that.showTost('请输入对方会员账号');
        return;
      }
      if (username == that.$store.state.userInfo.username) {
        that.showTost('不能转账给自己');
        return;
      }
      if (!amount || amount * 1 <= 0) {
        that.showTost('请输入正确的转账金额');
        return;
      }
      if (amount * 1 > that.$store.state.userInfo.balance * 1) {
        that.showTost('中心钱包余额不足');
        return;
      }
      if (!password) {
        that.showTost('请输入您的支付密码');
        return;
      }
      if (!window.confirm('确定将 ' + amount + ' 元转给会员【' + username + '】吗？')) {
        return;
      }
      that.submitting = true;
      that.showloading();
      that.$apiFun
        .post('/api/membertransfer', { username, amount, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(res.message || '转账失败');
          }
          if (res.code == 200) {
            that.showTost('转账成功');
            that.username = null;
            that.amount = null;
            that.password = null;
            that.refreshusermoney();
          }
          that.hideloading();
        })
        .catch(() => {
          that.showTost('网络连接错误，请稍后再试');
          that.hideloading();
        })
        .finally(() => {
          that.submitting = false;
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    showTost(title) {
      $('body').append(`
            <div class='ant-message' style='top: 400px;'><span><div class='ant-message-notice'><div class='ant-message-notice-content'>
            <div class='ant-message-custom-content ant-message-info'><span role='img' aria-label='info-circle' class='anticon anticon-info-circle'>
            <svg viewBox='64 64 896 896' focusable='false' data-icon='info-circle' width='1em' height='1em' fill='currentColor' aria-hidden='true'>
            <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'></path></svg></span><span>
            ${title}
            </span></div></div></div></span>
            </div>`);
      setTimeout('$(".ant-message").detach()', 2000);
    },
    hideloading() {
      this.lodingShow = false;
    },
    showloading() {
      this.lodingShow = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.z0QZN3OV--disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/memberTransfer.vue